<!-- 白色卡片，左图标，右文字 -->
<template>
  <div class="cardBox" :style="{ width: props.width }">
    <OssImg class="cardIcon" v-if="isShowIcon" :style="{ width: props.picSize, height: props.picSize }" :src="info.icon"
      alt="" />
    <div class="cardText">
      <OssImg v-if="info.miniIcon" class="miniIcon" :src="info.miniIcon" alt="" />
      <div>{{ info.title }}</div>
      <div :style="textStyle">{{ info.subTitle }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  //卡片尺寸
  width: {
    type: String,
    default: "100%",
  },
  //图标尺寸，如100%，1rem,10px
  picSize: {
    type: String,
    default: "7.5rem",
  },
  isShowIcon: {
    type: Boolean,
    default: true,
  },
  //展示信息
  info: {
    type: Object,
    default: {
      icon: "",
      title: "",
      subTitle: "",
    },
  },
  textStyle: {
    type: Object,
    default: {},
  },
});
</script>

<style lang="scss" scoped>
.cardBox {
  width: 59.125rem;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  background: #fff;
  margin: auto;

  .cardIcon {
    width: 7.5rem;
    height: 7.5rem;
    margin-right: 1rem;
  }

  .cardText {
    >div:first-of-type {
      color: #424242;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.375rem;
    }

    >div:nth-of-type(2) {

      margin-top: 1rem;
      color: #888888;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      text-align: justify;
    }
  }

  .miniIcon {
    width: 3rem;
    height: 3rem;
    margin-bottom: 1rem;
  }
}

@media (max-width: 768px) {}
</style>
